module.exports = __webpack_public_path__ + "img/1476.b7abfd16.gif";